import { DEFAULT_SECTIONS, ProductTypeConfig } from '../types';

/**
 * 1230 - Barrier Reverse Convertible
 * Autocall variant
 *
 * Shows: barrier info, strike levels, barrier levels, early redemption with levels
 * No: cap, upside participation
 */
export const config1230Autocall: ProductTypeConfig = {
  code: '1230',
  callableType: 'Autocall',
  name: 'Barrier Reverse Convertible',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
        autocallDistance: true, // Only for Autocall: show distance from autocall
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: true, // Autocall shows redemption level %
        showIssuerCallable: false,
      },
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};

/**
 * 1230 - Barrier Reverse Convertible
 * Callable variant
 *
 * Shows: barrier info, strike levels, barrier levels, early redemption (issuer callable)
 * No: cap, upside participation
 */
export const config1230Callable: ProductTypeConfig = {
  code: '1230',
  callableType: 'Callable',
  name: 'Barrier Reverse Convertible',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    earlyRedemption: {
      ...DEFAULT_SECTIONS.earlyRedemption,
      enabled: true,
      props: {
        observationDate: true,
        redemptionLevel: false, // Callable doesn't show % level
        showIssuerCallable: true, // Shows "Issuer Callable" text
      },
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};

/**
 * 1230 - Barrier Reverse Convertible
 * Standard variant (non-callable)
 *
 * Shows: barrier info, strike levels, barrier levels, coupons
 * No: cap, upside participation, early redemption
 */
export const config1230Standard: ProductTypeConfig = {
  code: '1230',
  callableType: 'Standard',
  name: 'Barrier Reverse Convertible',
  sections: {
    ...DEFAULT_SECTIONS,

    atGlance: {
      ...DEFAULT_SECTIONS.atGlance,
      props: {
        ...DEFAULT_SECTIONS.atGlance.props,
        coupon: true,
        upside: false,
        upsideParticipation: false,
        cap: false,
        distanceToCap: false,
        issuePricePct: false,
        settlementType: true,
      },
    },

    barrier: {
      ...DEFAULT_SECTIONS.barrier,
      enabled: true,
      props: {
        barrierType: true,
        strikeLevel: true,
        strikeDistance: true,
        barrierLevel: true,
        barrierDistance: true,
        barrierHit: true,
        stopLoss: false,
        distanceStopLoss: false,
      },
    },

    underlyings: {
      ...DEFAULT_SECTIONS.underlyings,
      props: {
        barrierLevel: true,
        barrierDistance: true,
      },
    },

    coupons: {
      enabled: true,
      props: {},
    },

    // Standard: NO early redemption
    earlyRedemption: {
      enabled: false,
      props: {},
    },

    performance: {
      enabled: true,
      props: {},
    },
  },
};
